'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBar = exports.CAROUSEL_SELECTOR = exports.CONTAINER_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CarouselSection2 = require('./../../sections/carousel/CarouselSection');

var _ShopifySection = require('./../../sections/ShopifySection');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Top Bar
 *    Scripts for the Top Bar object.
 *
 *  Version:
 *    1.0.0 - 2020/05/16
 */

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-topbar]';
var CAROUSEL_SELECTOR = exports.CAROUSEL_SELECTOR = '[data-topbar-carousel]';

var TopBar = exports.TopBar = function (_CarouselSection) {
  (0, _inherits3.default)(TopBar, _CarouselSection);

  function TopBar(container) {
    (0, _classCallCheck3.default)(this, TopBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TopBar.__proto__ || Object.getPrototypeOf(TopBar)).call(this, container));

    _this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    if (_this.carouselContainer.length) {
      _this.slick = _this.initCarousel(_this.carouselContainer);
    }
    return _this;
  }

  (0, _createClass3.default)(TopBar, [{
    key: 'optionOverrides',
    value: function optionOverrides() {
      return {
        infinite: this.container.data('infinite') === true ? true : false,
        autoplay: this.container.data('autoplay') == true,
        autoplaySpeed: this.container.data('autoplay-speed') * 1000 || 5000,
        arrows: false,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true
      };
    }
  }]);
  return TopBar;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, TopBar);